import { InMemoryCache } from '@apollo/client/core';
import possibleTypes from '@/shared/apollo-api/models/possibleTypes.json';

export const cache: InMemoryCache = new InMemoryCache({
  possibleTypes,
});
